module.exports = __webpack_public_path__ + "static/media/SerieMH.d17354ba.pdf";